export default __webpack_public_path__ + "static/media/Circles2.aaf3f828.png";